import { AxiosResponse } from 'axios';
import axios from '../helpers/axios';
import { logError } from '../services';
import {
  ICompactionTestNeighborhood,
  ICompactionTestJob,
  ICompactionTestFile
} from '../models/compaction-tests';

export const getCompactionTestNeighborhoods = async (): Promise<ICompactionTestNeighborhood[]> => {
  try {
    const { data } = await axios.get('/api/job-compaction-tests/neighborhoods');
    return data;
  } catch (error) {
    logError(error, 'getCompactionTestNeighborhoods failed');
    return Promise.reject(error);
  }
};

export const getCompactionTestJobs = async (
  neighborhoodId: number | string
): Promise<ICompactionTestJob[]> => {
  try {
    const { data } = await axios.get(`/api/job-compaction-tests/neighborhoods/${neighborhoodId}/jobs`);
    return data;
  } catch (error) {
    logError(error, 'getCompactionTestJobs failed');
    return Promise.reject(error);
  }
};

export const getCompactionTestFiles = async (
  jobId: number | string
): Promise<ICompactionTestFile[]> => {
  try {
    const { data } = await axios.get(`/api/job-compaction-tests/${jobId}/compaction-test-files`);
    return data;
  } catch (error) {
    logError(error, 'getCompactionTestFiles failed');
    return Promise.reject(error);
  }
};

export const uploadCompactionTestFile = async (
  jobId: number | string,
  payload: FormData
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `/api/job-compaction-tests/job/${jobId}/upload`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return data;
  } catch (error) {
    logError(error, 'uploadCompactionTestFile failed');
    return Promise.reject(error);
  }
};

export const downloadCompactionTestFile = async (
  jobId: number | string,
  token?: string | null
): Promise<AxiosResponse> => {
  try {
    const config: any = {
      responseType: 'blob'
    };

    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      };
    }

    return await axios.get(`/api/job-compaction-tests/${jobId}`, config);
  } catch (error) {
    logError(error, 'downloadCompactionTestFile failed');
    return Promise.reject(error);
  }
};

export const downloadCompactionTestFileVersion = async (
  compactionTestFileVersionId: number | string,
  token?: string | null
): Promise<AxiosResponse> => {
  try {
    const config: any = {
      responseType: 'blob'
    };

    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`
      };
    }

    return await axios.get(`/api/job-compaction-tests/version/${compactionTestFileVersionId}`, config);
  } catch (error) {
    logError(error, 'downloadCompactionTestFileVersion failed');
    return Promise.reject(error);
  }
};